import { Box, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";
import React from "react";

type ModalHandlerProps = {
  descriptionText: string;
  descriptionLinkText: string;
  handleClick: () => void;
};
export const ModalHandlerBlock: FC<ModalHandlerProps> = ({
  descriptionText,
  descriptionLinkText,
  handleClick,
}) => {
  return (
    <Box as="span" m={{ mt: 16 }} horizontalAlign="center">
      <Typography size="large" display="inline-block" m={{ mr: 8 }}>
        {descriptionText}
      </Typography>

      <Typography
        onClick={handleClick}
        size="large"
        display="inline-block"
        color="text-destructive"
        cursor="pointer"
      >
        {descriptionLinkText}
      </Typography>
    </Box>
  );
};
